export default {
    listagem: {
        titulo_pagina: 'Lista de Protocolos',
        novo: 'Criar novo Protocolo',
        table: {
            empty: 'Nenhum Protocolo encontrado',
            nome: 'Nome',
            classe: 'Classe',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Protocolo',
            editar: 'Editar Protocolo'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome do Protocolo'
            },
            classe: {
                label: 'Classe',
                description: 'Classe que executa o Protocolo'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Protocolo'
            },
            has_protocol_settings: {
                label: 'Configuração de protocolo',
                description: 'Configuração para protocolo Generico.'
            },
            protocol_settings: {
                label: 'Nome da configuração',
                description: 'Configuração para automizar extração de pedidos e resultados do protocolo.'
            },
            botao_salvar : 'Salvar Protocolo'
        },
        create: {
            success: 'Protocolo criado com Sucesso!',
            error: 'Error ao criar Protocolo!'
        },
        update: {
            success: 'Protocolo editado com Sucesso!',
            error: 'Error ao editar Protocolo!'
        }
    }
}
